import { camelCase } from 'lodash-es';
import Headroom from 'headroom.js';
function isJSON(text) {
    if (typeof text !== 'string') {
        return false;
    }
    try {
        JSON.parse(text);
        return true;
    }
    catch (error) {
    }
    return false;
}
function parseDataSet(dataset) {
    Object.keys(dataset).forEach((key) => {
        const value = dataset[key];
        switch (true) {
            case 'true' === value:
                dataset[key] = true;
                break;
            case 'false' === value:
                dataset[key] = false;
                break;
            case isJSON(value):
                dataset[key] = JSON.parse(value);
                break;
            default:
                break;
        }
    });
    const data = {};
    Object.keys(dataset).forEach((key) => {
        data[camelCase(key)] = dataset[key];
    });
    return data;
}
export default {
    init() {
        const navbarElement = document.querySelector('.navbar.header.fixed-top');
        const headroom = new Headroom(navbarElement);
        headroom.init();
        const toggleButtons = document.querySelectorAll('[data-ht-toggle="slidein"]');
        [].forEach.call(toggleButtons, (button) => {
            if (!(button instanceof HTMLElement)) {
                return;
            }
            const data = parseDataSet(Object.assign({}, button.dataset));
            let target = null;
            if (data.target) {
                target = document.querySelector(data.target);
                if (target) {
                    window.requestAnimationFrame(() => {
                        window.requestAnimationFrame(() => {
                            target.classList.add('initialized');
                        });
                    });
                }
            }
            let lock = null;
            if (data.lock) {
                lock = document.querySelector(data.lock);
            }
            button.addEventListener('click', (e) => {
                if ([...target.classList].includes('show')) {
                    if (target) {
                        target.classList.remove('show');
                        target.classList.add('disable-content');
                    }
                    button.classList.remove('is-open');
                    button.setAttribute('aria-expanded', '1');
                    if (lock) {
                        lock.classList.remove('disable-content');
                    }
                }
                else {
                    if (target) {
                        target.classList.add('show');
                        target.classList.remove('disable-content');
                    }
                    button.classList.add('is-open');
                    button.setAttribute('aria-expanded', '');
                    if (lock) {
                        lock.classList.add('disable-content');
                    }
                }
            });
        });
    },
    finalize() {
        $('[data-bs-toggle="tooltip"]').tooltip();
    },
};
